"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.mapAlertGroupToLevels = exports.levelMapper = exports.levelColours = exports.AlertLevel = exports.AlertIcon = void 0;
exports.createAlertSvg = createAlertSvg;
exports.createDataUrl = createDataUrl;
/*
 * © 2026 Renishaw plc. All rights reserved.
 * This source file is the confidential property and copyright of Renishaw plc
 * Reproduction or transmission in whole or in part, in any form or
 * by any means, electronic, mechanical or otherwise, is prohibited
 * without the prior written consent of the copyright owner.
 */
const react_1 = __importStar(require("react"));
const react_i18next_1 = require("react-i18next");
const level_1 = require("./level");
const toDataUrl = (data, mimeType = "image/svg+xml") => {
    return `data:${mimeType},${encodeURIComponent(data)}`;
};
/**
 * Return the SVG icon string
 */
function createAlertSvg({ level, size, fill, }) {
    // Validate size is a positive number
    let validSize = size;
    if (!Number.isFinite(size) || size <= 0) {
        console.warn(`AlertIcon: Invalid size ${size}. Size must be a positive number. Defaulting to 16.`);
        validSize = 16;
    }
    const normLevel = (0, level_1.levelMapper)(level);
    const iconColor = fill || level_1.levelColours[normLevel] || "currentcolor";
    let path;
    // Most of these icons have a 16x16 viewBox, but some have 64x64
    let boxSize = 16;
    switch (normLevel) {
        case level_1.AlertLevel.error:
            path = `<path d="M10.5 2h-5L2 5.5v5L5.5 14h5l3.5-3.5v-5zM9 12H7v-2h2zm0-3H7V4h2z"/>`;
            break;
        case level_1.AlertLevel.info:
            path = `<path d="M8,2C4.7,2 2,4.7 2,8c0,3.3 2.7,6 6,6 3.3,0 6,-2.7 6,-6C14,4.7 11.3,2 8,2 Zm1,9 1,2H7V8L6,6H9ZM9,5H7V3h2z"/>`;
            break;
        case level_1.AlertLevel.warning:
            path = `<path d="M14.9 12.7L8.7 1.4c-.3-.5-1-.5-1.3 0L1.1 12.7c-.3.6.1 1.3.7 1.3h12.5c.5 0 .9-.7.6-1.3zM9 12H7v-2h2zm0-3H7V4h2z"/>`;
            break;
        case level_1.AlertLevel.grouped:
            path = `<path d="M50,46H32H14l1.8-3.2c1.9-2.4,3.1-6,3.5-10.9c0,0,0,0,0,0c0.1-1.6,0.2-3.4,0.1-5.3c0-6,3.4-11.4,9-12.6
        c0-2,1.6-3.6,3.6-3.6s3.6,1.6,3.6,3.6c5.6,1.2,9,6.6,9,12.6c0,1.9,0,3.7,0.1,5.3c0,0,0,0,0,0c0.4,4.9,1.5,8.5,3.5,10.9L50,46z
        M26,48h12c0,3.3-2.7,6-6,6S26,51.3,26,48z"/>`;
            boxSize = 64;
            break;
        case level_1.AlertLevel.mastering:
            path = `<path d="m8 2 1.95 3.94 4.32 0.628-3.14 3.07 0.732 4.32-3.87-2.06-3.87 2.02 0.732-4.32-3.14-3.03 4.32-0.628z" />`;
            break;
        case level_1.AlertLevel.masteringGrouped:
            path = `<path opacity="0.6"
        d="m7.11 3.24 1.6-3.24 1.95 3.94 4.32 0.628-2.48 2.44-3.84-0.558zm-3.07 2.86-1.6-1.53 2.55-0.384zm8.06 3 0.488 2.82-2.2-1.15z" />
        <path d="m6.28 3.14 1.95 3.94 4.32 0.628-3.14 3.07 0.732 4.32-3.87-2.06-3.87 2.02 0.732-4.32-3.14-3.03 4.32-0.628z" />`;
            break;
        case level_1.AlertLevel.errorGrouped:
            path = `<path d="M9.5 3h-5L1 6.5v5L4.5 15h5l3.5-3.5v-5L9.5 3zM8 13H6v-2h2v2zm0-3H6V5h2v5z"/>
      <path opacity=".6" d="M15 4.5v5l-1 1V6.1L9.9 2H5.5l1-1h5L15 4.5z"/>`;
            break;
        case level_1.AlertLevel.warningGrouped:
            path = `<path opacity=".6" d="M8.5 1.9c-.1-.3-.4-.5-.6-.6l.5-.8c.3-.5 1-.5 1.3 0l6.2 11.3c.3.6-.1 1.3-.7 1.3h-.6L8.5 1.9z"/>
      <path d="M13.9 13.7L7.7 2.4c-.3-.5-1-.5-1.3 0L.1 13.7c-.3.6.1 1.3.7 1.3h12.5c.5 0 .9-.7.6-1.3zM8 13H6v-2h2v2zm0-3H6V5h2v5z"/>`;
            break;
        case level_1.AlertLevel.infoGrouped:
            path = `<path d="M7 3C3.7 3 1 5.7 1 9s2.7 6 6 6 6-2.7 6-6-2.7-6-6-6zm1 4v5l1,2H6V9L5 7h3zm0-1H6V4h2v2z"/>
      <path opacity="0.6" d="M5.5,2.2a6.9 6.9 0 0 1 8.3,8.3 5.925 5.925 0 0 0 -8.3 -8.3z"/>`;
            break;
        // Offset Applied, wear < offsetWarningMin; fallback for unknown offset events
        case level_1.AlertLevel.offset:
            path = `<path d="M8 2.5C5 2.5 2.5 5 2.5 8S5 13.5 8 13.5 13.5 11 13.5 8 11 2.5 8 2.5zM8 1c3.9 0 7 3.1 7 7s-3.1 7-7 7-7-3.1-7-7 3.1-7 7-7z"/>
      <path d="M8 5.5C6.6 5.5 5.5 6.6 5.5 8s1.1 2.5 2.5 2.5 2.5-1.1 2.5-2.5S9.4 5.5 8 5.5zM8 4c2.2 0 4 1.8 4 4s-1.8 4-4 4-4-1.8-4-4 1.8-4 4-4z" opacity=".7"/>
      <path d="M7 7h2v2H7V7z"/>`;
            break;
        case level_1.AlertLevel.offsetGrouped:
            path = `<path d="M7 3.5C4 3.5 1.5 6 1.5 9S4 14.5 7 14.5 12.5 12 12.5 9 10 3.5 7 3.5zM7 2c3.9 0 7 3.1 7 7s-3.1 7-7 7-7-3.1-7-7 3.1-7 7-7z"/>
      <path d="M7 6.5C5.6 6.5 4.5 7.6 4.5 9s1.1 2.5 2.5 2.5S9.5 10.4 9.5 9 8.4 6.5 7 6.5zM7 5c2.2 0 4 1.8 4 4s-1.8 4-4 4-4-1.8-4-4 1.8-4 4-4z" opacity=".7"/>
      <path d="M6 8h2v2H6V8z"/><path d="M9 0c3.9 0 7 3.1 7 7 0 1.5-.5 2.9-1.3 4 .2-.6.3-1.3.3-2 0-4.4-3.6-8-8-8-.7 0-1.4.1-2 .3C6.1.5 7.5 0 9 0z" opacity=".7"/>`;
            break;
        // Offset Applied, offsetWarningMin <= wear < offsetErrorMin
        case level_1.AlertLevel.offsetWarning:
            path = `<path d="M8 2.5C5 2.5 2.5 5 2.5 8S5 13.5 8 13.5 13.5 11 13.5 8 11 2.5 8 2.5zM8 1c3.9 0 7 3.1 7 7s-3.1 7-7 7-7-3.1-7-7 3.1-7 7-7z"/>
      <path d="M7 7h2v2H7V7z"/><path d="M7.1 10.3c.3.1.6.2.9.2.3 0 .6-.1.9-.2l1.1 1.1c-.6.4-1.3.6-2 .6s-1.4-.2-2-.6l1.1-1.1zM11.4 6c.4.6.6 1.3.6 2s-.2 1.4-.6 2l-1.1-1.1c.1-.3.2-.6.2-.9 0-.3-.1-.6-.2-.9L11.4 6zM4.6 6l1.1 1.1c-.1.3-.2.6-.2.9 0 .3.1.6.2.9L4.6 10C4.2 9.4 4 8.7 4 8s.2-1.4.6-2zM8 4c.7 0 1.4.2 2 .6L8.9 5.7c-.3-.1-.6-.2-.9-.2-.3 0-.6.1-.9.2L6 4.6c.6-.4 1.3-.6 2-.6z" opacity=".7"/>`;
            break;
        case level_1.AlertLevel.offsetWarningGrouped:
            path = `<path d="M7 3.5C4 3.5 1.5 6 1.5 9S4 14.5 7 14.5 12.5 12 12.5 9 10 3.5 7 3.5zM7 2c3.9 0 7 3.1 7 7s-3.1 7-7 7-7-3.1-7-7 3.1-7 7-7z"/>
      <path d="M6 8h2v2H6V8z"/><path d="M6.1 11.3c.3.1.6.2.9.2.3 0 .6-.1.9-.2L9 12.4c-.6.4-1.3.6-2 .6s-1.4-.2-2-.6l1.1-1.1zM10.4 7c.4.6.6 1.3.6 2s-.2 1.4-.6 2L9.3 9.9c.1-.3.2-.6.2-.9 0-.3-.1-.6-.2-.9L10.4 7zM3.6 7l1.1 1.1c-.1.3-.2.6-.2.9 0 .3.1.6.2.9L3.6 11c-.4-.6-.6-1.3-.6-2s.2-1.4.6-2zM7 5c.7 0 1.4.2 2 .6L7.9 6.7c-.3-.1-.6-.2-.9-.2-.3 0-.6.1-.9.2L5 5.6c.6-.4 1.3-.6 2-.6zM9 0c3.9 0 7 3.1 7 7 0 1.5-.5 2.9-1.3 4 .2-.6.3-1.3.3-2 0-4.4-3.6-8-8-8-.7 0-1.4.1-2 .3C6.1.5 7.5 0 9 0z" opacity=".7"/>`;
            break;
        // Offset Applied, wear >= offsetErrorMin
        case level_1.AlertLevel.offsetError:
            path = `<path d="M8 2.5C5 2.5 2.5 5 2.5 8S5 13.5 8 13.5 13.5 11 13.5 8 11 2.5 8 2.5zM8 1c3.9 0 7 3.1 7 7s-3.1 7-7 7-7-3.1-7-7 3.1-7 7-7zm-1 9h2v2H7v-2zm0-6h2v5H7V4z"/>
      <path d="M10 4.6a3.87 3.87 0 0 1 0 6.8V9.5c.3-.4.5-.9.5-1.5s-.2-1.1-.5-1.5V4.6zm-4 0v1.9c-.3.4-.5.9-.5 1.5s.2 1.1.5 1.5v1.9A4 4 0 0 1 4 8a4 4 0 0 1 2-3.4z" opacity=".7"/>`;
            break;
        case level_1.AlertLevel.offsetErrorGrouped:
            path = `<path d="M7 3.5C4 3.5 1.5 6 1.5 9S4 14.5 7 14.5 12.5 12 12.5 9 10 3.5 7 3.5zM7 2c3.9 0 7 3.1 7 7s-3.1 7-7 7-7-3.1-7-7 3.1-7 7-7z"/>
      <path d="M6 11h2v2H6v-2zM6 5h2v5H6V5z"/>
      <path d="M9 5.6c1.2.7 2 1.9 2 3.4s-.8 2.7-2 3.4v-1.9c.3-.4.5-.9.5-1.5S9.3 7.9 9 7.5V5.6zM5 5.6v1.9c-.3.4-.5.9-.5 1.5s.2 1.1.5 1.5v1.9c-1.2-.7-2-2-2-3.4s.8-2.7 2-3.4z" opacity=".7"/>
      <path d="M9 0c3.9 0 7 3.1 7 7 0 1.5-.5 2.9-1.3 4 .2-.6.3-1.3.3-2 0-4.4-3.6-8-8-8-.7 0-1.4.1-2 .3C6.1.5 7.5 0 9 0z" opacity=".6"/>`;
            break;
        // Offset Calculated (subtype: ToolOffsetCalculation, offsetMode: Control)
        case level_1.AlertLevel.offsetInfo:
            path = `<path d="M8 2.5C5 2.5 2.5 5 2.5 8S5 13.5 8 13.5 13.5 11 13.5 8 11 2.5 8 2.5zM8 1c3.9 0 7 3.1 7 7s-3.1 7-7 7-7-3.1-7-7 3.1-7 7-7z"/>
      <path d="M7 4h2v2H7V4zM7 7h2v5H7V7z"/>
      <path d="M6 4.6v1.9c-.3.4-.5.9-.5 1.5s.2 1.1.5 1.5v1.9C4.8 10.7 4 9.5 4 8s.8-2.7 2-3.4zM10 4.6c1.2.7 2 2 2 3.4s-.8 2.7-2 3.4V9.5c.3-.4.5-.9.5-1.5s-.2-1.1-.5-1.5V4.6z" opacity=".7"/>`;
            break;
        case level_1.AlertLevel.offsetInfoGrouped:
            path = `<path d="M6 5h2v2H6V5zM6 8h2v5H6V8z"/>
      <path d="M7 3.5C4 3.5 1.5 6 1.5 9S4 14.5 7 14.5 12.5 12 12.5 9 10 3.5 7 3.5zM7 2c3.9 0 7 3.1 7 7s-3.1 7-7 7-7-3.1-7-7 3.1-7 7-7z"/>
      <path d="M5 5.6v1.9c-.3.4-.5.9-.5 1.5s.2 1.1.5 1.5v1.9c-1.2-.7-2-1.9-2-3.4s.8-2.7 2-3.4zM9 5.6c1.2.7 2 2 2 3.4s-.8 2.7-2 3.4v-1.9c.3-.4.5-.9.5-1.5S9.3 7.9 9 7.5V5.6z" opacity=".7"/>
      <path d="M9 0c3.9 0 7 3.1 7 7 0 1.5-.5 2.9-1.3 4 .2-.6.3-1.3.3-2 0-4.4-3.6-8-8-8-.7 0-1.4.1-2 .3C6.1.5 7.5 0 9 0z" opacity=".6"/>`;
            break;
        // Offset Applied, mode: Set
        case level_1.AlertLevel.offsetOther:
            path = `<path d="M7 7h2v2H7V7z"/>
      <path d="M8 1c3.9 0 7 3.1 7 7s-3.1 7-7 7c-3.5 0-6.4-2.6-6.9-6h2c.5 2.3 2.5 4 4.9 4 2.8 0 5-2.2 5-5s-2.2-5-5-5C5.6 3 3.6 4.7 3.1 7h-2C1.6 3.6 4.5 1 8 1z"/>
      <path d="m1 2 5 5H1V2z"/>`;
            break;
        case level_1.AlertLevel.offsetOtherGrouped:
            path = `<path d="M6 8h2v2H6V8z"/>
      <path d="M7 2c3.9 0 7 3.1 7 7s-3.1 7-7 7C3.5 16 .6 13.4.1 10h2c.5 2.3 2.5 4 4.9 4 2.8 0 5-2.2 5-5S9.8 4 7 4C4.6 4 2.6 5.7 2.1 8h-2C.6 4.6 3.5 2 7 2z"/>
      <path d="m0 3 5 5H0V3z"/>
      <path d="M9 0c3.9 0 7 3.1 7 7 0 1.5-.5 2.9-1.3 4 .2-.6.3-1.3.3-2 0-4.4-3.6-8-8-8-.7 0-1.4.1-2 .3C6.1.5 7.5 0 9 0z" opacity=".6"/>`;
            break;
        // Tool Change Detected
        case level_1.AlertLevel.offsetOtherInfo:
            path = `<path d="M7 4h2v2H7V4zM7 7h2v5H7V7z"/>
      <path d="M8 1c3.9 0 7 3.1 7 7s-3.1 7-7 7c-3.5 0-6.4-2.6-6.9-6h2c.5 2.3 2.5 4 4.9 4 2.8 0 5-2.2 5-5s-2.2-5-5-5C5.6 3 3.6 4.7 3.1 7h-2C1.6 3.6 4.5 1 8 1z"/>
      <path d="m1 2 5 5H1V2z"/>`;
            break;
        case level_1.AlertLevel.offsetOtherInfoGrouped:
            path = `<path d="M6 5h2v2H6V5zM6 8h2v5H6V8z"/>
      <path d="M7 2c3.9 0 7 3.1 7 7s-3.1 7-7 7C3.5 16 .6 13.4.1 10h2c.5 2.3 2.5 4 4.9 4 2.8 0 5-2.2 5-5S9.8 4 7 4C4.6 4 2.6 5.7 2.1 8h-2C.6 4.6 3.5 2 7 2z"/>
      <path d="m0 3 5 5H0V3z"/>
      <path d="M9 0c3.9 0 7 3.1 7 7 0 1.5-.5 2.9-1.3 4 .2-.6.3-1.3.3-2 0-4.4-3.6-8-8-8-.7 0-1.4.1-2 .3C6.1.5 7.5 0 9 0z" opacity=".6"/>`;
            break;
        default:
            path = `<path d="M8.5,13.3c-0.2,0.2-0.5,0.3-0.8,0.3c-0.3,0-0.6-0.1-0.8-0.3c-0.2-0.2-0.4-0.5-0.4-0.8c0-0.3,0.1-0.6,0.4-0.8
          c0.2-0.2,0.5-0.3,0.8-0.3c0.3,0,0.6,0.1,0.8,0.3c0.2,0.2,0.4,0.5,0.4,0.8C8.8,12.8,8.7,13,8.5,13.3z"/>
          <path d="M10.6,6c-0.1,0.3-0.3,0.6-0.5,0.8C9.9,7.1,9.7,7.3,9.5,7.5C9.3,7.6,9.1,7.8,8.9,8C8.7,8.2,8.5,8.4,8.4,8.6
          C8.3,8.7,8.3,8.9,8.3,9.1c0,0.2,0,0.4,0.1,0.5c0.1,0.2,0.1,0.3,0.1,0.4l0.1,0.2H6.7l0-0.1c0-0.1-0.1-0.3-0.1-0.5
          c0-0.2-0.1-0.4-0.1-0.6c0-0.3,0.1-0.6,0.2-0.9C6.8,8,7,7.8,7.2,7.5c0.2-0.2,0.4-0.4,0.6-0.6c0.2-0.2,0.4-0.4,0.6-0.6
          C8.5,6.2,8.6,6,8.7,5.8c0.1-0.2,0.2-0.4,0.2-0.6c0-0.2,0-0.3-0.1-0.5C8.7,4.6,8.6,4.5,8.4,4.4C8.3,4.3,8.2,4.3,8,4.2
          c-0.2,0-0.4-0.1-0.6-0.1C6.7,4.1,6.1,4.4,5.5,5L5.2,5.3V3.2l0.1,0c0.8-0.5,1.7-0.7,2.5-0.7c0.4,0,0.8,0.1,1.1,0.2
          c0.4,0.1,0.7,0.3,1,0.5c0.3,0.2,0.5,0.5,0.7,0.8c0.2,0.3,0.2,0.7,0.2,1.1C10.8,5.3,10.7,5.7,10.6,6z"/>`;
            break;
    }
    return `<svg xmlns="http://www.w3.org/2000/svg" width="${validSize}" height="${validSize}" viewBox="0 0 ${boxSize} ${boxSize}" preserveAspectRatio="xMidYMid meet">
    <g fill="${iconColor}">
    ${path.replace(/\s{2,}/g, " ")}
    </g>
  </svg>`;
}
/**
 * Return the SVG as a data URL
 */
function createDataUrl(args) {
    const svg = createAlertSvg(args);
    return toDataUrl(svg);
}
/**
 * The SVG icon for a type of alert, as an <img> element.
 */
const AlertIcon = ({ cleared = false, level = level_1.AlertLevel.unknown, size = 16, className, title, fill, }) => {
    const { t } = (0, react_i18next_1.useTranslation)();
    const text = level + (cleared ? ` (${t `message-Cleared`})` : "");
    const memoizedSvg = (0, react_1.useMemo)(() => createAlertSvg({
        cleared: cleared,
        level: level,
        size: size,
        fill: fill,
    }), [cleared, level, size, fill]);
    const memoizedUrl = (0, react_1.useMemo)(() => toDataUrl(memoizedSvg), [memoizedSvg]);
    return (react_1.default.createElement("img", { className: className, src: memoizedUrl, alt: text, title: title, height: size, width: size }));
};
exports.AlertIcon = AlertIcon;
var level_2 = require("./level");
Object.defineProperty(exports, "AlertLevel", { enumerable: true, get: function () { return level_2.AlertLevel; } });
Object.defineProperty(exports, "levelColours", { enumerable: true, get: function () { return level_2.levelColours; } });
Object.defineProperty(exports, "levelMapper", { enumerable: true, get: function () { return level_2.levelMapper; } });
Object.defineProperty(exports, "mapAlertGroupToLevels", { enumerable: true, get: function () { return level_2.mapAlertGroupToLevels; } });
//# sourceMappingURL=index.js.map